import { render, staticRenderFns } from "./AppMarkdown.vue?vue&type=template&id=420621b1"
import script from "./AppMarkdown.vue?vue&type=script&lang=js"
export * from "./AppMarkdown.vue?vue&type=script&lang=js"
import style0 from "./AppMarkdown.vue?vue&type=style&index=0&id=420621b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports